module.exports = __webpack_public_path__ + "img/index_pic29.c8e0c82f.png";